module.exports = __webpack_public_path__ + "static/media/lokmanyaweb-2.6d9d50f4.png";